import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d200ffe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mode-of-travel" }
const _hoisted_2 = {
  target: "_blank",
  href: "/routes/"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "icon-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseRadio = _resolveComponent("BaseRadio")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, { disabled: _ctx.disabled }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", null, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("modeOfTravel.title")), 1),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("modeOfTravel.description")), 1),
            _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$t("modeOfTravel.link")), 1)
          ])
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOfTravel, (option) => {
            return (_openBlock(), _createElementBlock("li", {
              key: option.value
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.selectMode(option.value)),
                class: _normalizeClass(["mode-of-travel__radio", { active: option.value === _ctx.modeOfTravel }])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (option.value === _ctx.ModeOfTravelEnum.SailAndFly)
                    ? (_openBlock(), _createBlock(_component_BaseSvg, {
                        key: 0,
                        icon: 'vessel-ship',
                        class: _normalizeClass('ship')
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_BaseSvg, {
                    icon: option.icon,
                    class: _normalizeClass({ ship: option.icon === 'vessel-ship' })
                  }, null, 8, ["icon", "class"]),
                  (option.value === _ctx.ModeOfTravelEnum.FlyAndSail)
                    ? (_openBlock(), _createBlock(_component_BaseSvg, {
                        key: 1,
                        icon: 'vessel-ship',
                        class: _normalizeClass('ship')
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(), _createBlock(_component_BaseRadio, {
                  name: option.name,
                  id: option.name,
                  key: option.name,
                  label: option.label,
                  value: option.value,
                  modelValue: _ctx.modeOfTravel,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modeOfTravel) = $event))
                }, null, 8, ["name", "id", "label", "value", "modelValue"]))
              ], 10, _hoisted_3)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["disabled"]))
}